import { ConfirmTransferScreenProps } from "../useConfirmTransfer";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Footer from "../../../components/footer";
import HeadingContainer from "../../../layout/heading-container";
import { BodyLargeBold, BodyMediumRegular, HeadlineMedium, Highlight, LabelMedium } from "../../../components/font";
import { Button, tokens } from "@manifesthhqinc/ui-library";
import { AnnuityContactCardDiv, ContactRow } from "../../post-transfer/styles";
import phone from "../../post-transfer/assets/phone.svg";
import email from "../../post-transfer/assets/mail.svg";

const IDVerificationFailed = (props: ConfirmTransferScreenProps) => {
  const { clickExitManifest, partnerConfig } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="open-ira-exit-screen">
        <Container>
          <HeadingContainer paneVariant="vector" withProgressBar={false}>
            <HeadlineMedium $textAlign="center">
              Contact <Highlight>{partnerConfig || ""} </Highlight>
            </HeadlineMedium>
            <BodyMediumRegular $textAlign="center">
              {partnerConfig} requires identity verification before your transfer can continue. We were unable to
              complete identity verification online. Please contact {partnerConfig} for next steps.
            </BodyMediumRegular>
          </HeadingContainer>

          <AnnuityContactCardDiv>
            <BodyLargeBold>Pacific Life Support</BodyLargeBold>
            <BodyMediumRegular $color={tokens.color.text.secondary}>
              For help completing your transfer:
            </BodyMediumRegular>
            <div className="divider" />
            <ContactRow>
              <img src={phone} alt="phone" />
              <LabelMedium $underline>
                <Highlight>877-378-0386</Highlight>
              </LabelMedium>
            </ContactRow>
            <ContactRow>
              <img src={email} alt="phone" />
              <LabelMedium $underline>
                <Highlight>retirementincome@pacificlife.com</Highlight>
              </LabelMedium>
            </ContactRow>
          </AnnuityContactCardDiv>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button onClick={clickExitManifest} name="exit-manifest" size="large">
          Exit Manifest
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default IDVerificationFailed;
